import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    console.error('API Error:', error)
    return Promise.reject(error)
  }
)

// 分类 API
export const categoryApi = {
  list: (type) => api.get('/categories', { params: { type } })
}

// AI网站 API
export const siteApi = {
  list: (category) => api.get('/sites', { params: { category } })
}

// 在线工具 API
export const toolApi = {
  list: (category) => api.get('/tools', { params: { category } })
}

// 书籍 API
export const bookApi = {
  list: (category) => api.get('/books', { params: { category } })
}

// 电影 API
export const movieApi = {
  list: (category) => api.get('/movies', { params: { category } })
}

// 视频 API
export const videoApi = {
  list: (category) => api.get('/videos', { params: { category } })
}

export default api
